import type { LucideIcon } from 'lucide-react';
import { ChevronLeftIcon, XIcon } from 'lucide-react';
import type React from 'react';
import { cn } from '../../lib/utils.ts';
import { Button } from './button.tsx';
import { Heading } from './heading.tsx';
import { TooltipInfo } from './tooltip.tsx';

export type HeaderProps = {
    title?: React.ReactNode;
    subTitle?: string;
    actions?: React.ReactNode;
    onBack?: () => void;
    onClose?: () => void;
    icon?: LucideIcon;
    className?: string;
} & React.PropsWithChildren;

export const Header = ({
    className,
    title,
    actions,
    subTitle,
    onBack,
    onClose,
    icon: Icon,
    children,
}: HeaderProps) => {
    return (
        <div className={cn('flex flex-col gap-2', className)}>
            <div className="flex flex-row flex-wrap gap-3">
                <div className="flex gap-2 grow">
                    {onBack && <Button icon={ChevronLeftIcon} variant="icon" onClick={onBack} />}
                    <div className="flex grow flex-row items-center gap-2">
                        {Icon && <Icon className="h-4 w-4" />}
                        <Heading>{title}</Heading>
                        {subTitle && <TooltipInfo>{subTitle}</TooltipInfo>}
                        {children}
                    </div>
                </div>
                {(actions || onClose) && (
                    <div className="flex gap-3 flex-wrap">
                        {actions}
                        {onClose && <Button variant="icon" onClick={onClose} icon={XIcon} />}
                    </div>
                )}
            </div>
        </div>
    );
};
